import {
  type ExamCourseSettings,
  ExamEventCourseStatus,
  type ExamEventSession,
} from '@exam-center/graphql';
import { Box, FormSelection, Tooltip, type OptionSelectionProps } from '@shared/components';
import type { TableBodyRow } from '@shared/table-generator';
import { dayjs } from '@shared/utils';

type TableBodyRowChildren = TableBodyRow['children'][number];

export function createRows(
  examSession: Pick<ExamEventSession, 'id' | 'startedAt' | 'endedAt' | 'round'>[],
  examEventCourses: readonly {
    id: string;
    examCourse: {
      code: string;
      status: ExamEventCourseStatus;
      settings: Partial<Pick<ExamCourseSettings, 'examDuration'>>;
    };
    options: OptionSelectionProps[];
    value: OptionSelectionProps['value'];
  }[],
) {
  return [
    {
      children: examEventCourses.map((course) => {
        const isAllocated = course.examCourse.status === ExamEventCourseStatus.Allocated;

        const isExamRangeMatch =
          !!course.examCourse.settings.examDuration?.sessions.length &&
          examSession.length >= course.examCourse.settings.examDuration?.sessions.length &&
          course.examCourse.settings.examDuration?.sessions.every((durationSession) => {
            const matchedExamSession = examSession.find(
              (session) => session.round === durationSession.order,
            );

            if (!matchedExamSession) {
              return false;
            }

            return (
              dayjs(matchedExamSession.endedAt).diff(
                dayjs(matchedExamSession.startedAt),
                'seconds',
              ) >= durationSession.value
            );
          });

        return {
          children: (
            <Tooltip
              title={
                isExamRangeMatch ? (
                  ''
                ) : (
                  <>
                    ไม่สามารถเลือกหลักสูตรนี้ได้ <br />
                    เนื่องจากช่วงสอบหรือระยะเวลาสอบ
                    <br />
                    ไม่ตรงกับรอบสอบ
                  </>
                )
              }
              arrow
              placement='bottom'
            >
              <Box>
                <FormSelection
                  name={course.id}
                  options={course.options}
                  defaultValue={course.value}
                  size='small'
                  disabled={isAllocated || !isExamRangeMatch}
                />
              </Box>
            </Tooltip>
          ),
          rowSpan: 1,
        } as TableBodyRowChildren;
      }),
    },
  ];
}
